/*
 * @Author: hfxie
 * @Date: 2022-08-23 17:20:26
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-10-30 19:41:46
 * @Description: file content
 */
import Vue from "vue";
import * as utils from "@/utils/ganttUnit.js";
import CONSTNAME from "@/ConstName.js";
const mutation = {
  set_demo(state, demo) {
    state.demo = demo;
  },
  setUuid(state, id = "default") {
    state.uuid = id;
  },
  set_data(state, obj) {
    state.data = obj;
    console.log("更新数据: ", state);
  },
  set_totalWidth(state, num) {
    state.local.totalWidth = num;
    console.log("更新容器尺寸宽:", state);
  },

  set_local_filterStr(state, str) {
    state.local.filterStr = str;
  },
  set_filterStatus(state, status) {
    state.data.config.filterStatus = status;
    const arr = state.data.list.info;
    for (let i = 0; i < arr.length; i++) {
      const block = arr[i];
      block.isExpand = status;
      const _child = block.child;
      for (let j = 0; j < _child.length; j++) {
        if (_child[j].isExpand) {
          _child[j].isExpand = false;
          console.log("二级折叠");
        }
      }
    }
  },
  set_blockExpand(state, blockIndex) {
    const arr = state.data.list.info;
    const infoItem = arr[blockIndex];
    infoItem.isExpand = !infoItem.isExpand;
  },
  set_rowExpand(state, { zone, row }) {
    const path = row.path;
    let str = "state.data.list.info[" + path[0] + "]";
    for (let index = 1; index < path.length; index++) {
      str += `.child[${path[index]}]`;
    }
    // eslint-disable-next-line no-eval
    const aa = eval(str);
    const newStatus = !row.isExpand;
    Vue.set(aa, "isExpand", newStatus);
    // console.log(str, aa, newStatus);
  },
  set_dataLoadingStatus(state, status = false) {
    state.dataLoadingStatus = status;
  },
  set_noDataMsg(state, noDataMsg) {
    state.noDataMsg = noDataMsg;
    console.log("更新暂无数据提示语: ", noDataMsg);
  },

};
export default mutation;
